import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import EntityTable from '../common/entity/entityTable';
import Select from '../common/inputs/select';
import GlassPopup from '../common/interface/glassPopup';
import Button from '../common/inputs/button';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import LocaleTooling from '../../../tooling/localeTooling';

const DeleteCalculationInstancesDetailPopup = props => {
  const {
    handleShowPopup,
    handleRefresh,
    fullLoading,
    tableLoading,
    calculationInstancesDetailState,
    activeCalculationInstanceObject,
    handleCalculationInstancesNextPage,
    handleDeleteCalculationInstance,
    popupState
  } = props;
  let calculationInstancesDetailText = activeCalculationInstanceObject ? (
      intl.formatMessage({ id: "calculationsHistory.fields.period"}) + ": " + activeCalculationInstanceObject.period + " | " + 
      (activeCalculationInstanceObject.calculation_unit ? intl.formatMessage({ id: "calculationsHistory.fields.polynomial"}) : intl.formatMessage({ id: "calculationsHistory.fields.pre_polynomial"})) + ": " + activeCalculationInstanceObject.polynomial + " | " +
      (activeCalculationInstanceObject.calculation_unit ? LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: "calculationsHistory.fields.calculation_unit"})) + ": " + activeCalculationInstanceObject.calculation_unit : activeCalculationInstanceObject.dimension_name + ": " + activeCalculationInstanceObject.dimension_instance)
    ) : "";
  return (
    <GlassPopup
      className="form_popup calculation_instances_popup notifications_popup"
      title={(<FormattedMessage id={"calculationsHistory.deleteCalculationInstancesDetailPopupTitle"}/>)}
      handleButton={(calculationInstancesDetailState.paginationStatus && calculationInstancesDetailState.paginationStatus.total_not_blocked > 0) ? handleDeleteCalculationInstance : null}
      buttonText={(<FormattedMessage id={"calculationsHistory.deleteCalculationInstancesDetailPopupButton"}/>)}
      {...props}
    >
      <div>
        <label className="form_info">
          <FormattedMessage 
            id={"calculationsHistory.deleteCalculationInstancesDetailPopupHelp"}
          />
        </label>
        <EntityTable
          entityTableDescriptor={TableDescriptors.calculationInstancesDeleteList}
          data={calculationInstancesDetailState.data}
          loading={tableLoading}
          page={calculationInstancesDetailState.page}
          totalPages={calculationInstancesDetailState.totalPages}
          totalRecords={calculationInstancesDetailState.totalRecords}
          orderBy={calculationInstancesDetailState.orderBy}
          orderByDirection={calculationInstancesDetailState.orderByDirection}
          fetchListChangePage={handleCalculationInstancesNextPage}          
          handleDelete={handleDeleteCalculationInstance}
          extraControls={(
            <div className="filters_info" title={calculationInstancesDetailText}>
              {calculationInstancesDetailText}
            </div>
          )}
          colorConfig={[{
            color: "red",
            column: "has_error",
            value: true
          }]}
        />
      </div>
    </GlassPopup>
  );
};

export default DeleteCalculationInstancesDetailPopup;



// WEBPACK FOOTER //
// ./source/client/components/calculationsHistory/deleteCalculationInstancesDetailPopup.jsx